import { NotificationProvider } from "@4uhub/lib4uhub";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { captureChatLinkParams } from "./services/chatLink.service";
import { startChatWidget } from "./services/chatWidget.service";

captureChatLinkParams();

startChatWidget();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <NotificationProvider>
    <App />
  </NotificationProvider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
